module.exports = __webpack_public_path__ + "img/inactive-5.cf5a14ed.svg";